import React from 'react';
import { SparklesIcon, DollarSignIcon } from 'lucide-react';
interface RDSummaryCardProps {
  stipendUsed: number;
  stipendTotal: number;
  planApprovedCount: number;
  totalCount: number;
}
export function RDSummaryCard({
  stipendUsed,
  stipendTotal,
  planApprovedCount,
  totalCount
}: RDSummaryCardProps) {
  const percentage = totalCount > 0 ? Math.round(planApprovedCount / totalCount * 100) : 0;
  const stipendPercentage = Math.round(stipendUsed / stipendTotal * 100);
  const stipendRemaining = stipendTotal - stipendUsed;
  return <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl shadow-lg p-4 text-white mb-4" data-id="element-79">
      <div className="flex items-start gap-3 mb-3" data-id="element-80">
        <div className="bg-white/20 rounded-full p-2" data-id="element-81">
          <SparklesIcon className="w-6 h-6" data-id="element-82" />
        </div>
        <div className="flex-1" data-id="element-83">
          <h3 className="font-bold text-lg mb-1" data-id="element-84">Great choices!</h3>
          <p className="text-green-50 text-sm leading-relaxed" data-id="element-85">
            {planApprovedCount} of {totalCount} items are plan-approved (
            {percentage}%)
          </p>
        </div>
      </div>

      <div className="bg-white/20 rounded-xl p-3" data-id="element-86">
        <div className="flex items-center justify-between mb-2" data-id="element-87">
          <div className="flex items-center gap-2" data-id="element-88">
            <DollarSignIcon className="w-5 h-5" data-id="element-89" />
            <span className="font-semibold" data-id="element-90">Weekly Stipend</span>
          </div>
          <span className="font-bold text-lg" data-id="element-91">
            ${stipendUsed.toFixed(2)} / ${stipendTotal.toFixed(2)}
          </span>
        </div>
        <div className="w-full bg-white/30 rounded-full h-2 mb-2" data-id="element-92">
          <div className="bg-white rounded-full h-2 transition-all duration-300" style={{
          width: `${Math.min(stipendPercentage, 100)}%`
        }} data-id="element-93" />
        </div>
        <p className="text-green-50 text-xs" data-id="element-94">
          {stipendRemaining > 0 ? `$${stipendRemaining.toFixed(2)} remaining for plan-approved items` : 'Stipend fully used'}
        </p>
      </div>
    </div>;
}